module.exports = __webpack_public_path__ + "static/media/about-banner@mobile.1787d698.png";